const LOCALHOST_NAMES = new Set(['localhost', '127.0.0.1', '[::1]']);

export const isLocalhostDebug = () => {
  try {
    if (typeof window === 'undefined') return false;
    return LOCALHOST_NAMES.has(window.location.hostname);
  } catch {
    return false;
  }
};

const runLocalConsole = (method, args) => {
  if (!isLocalhostDebug()) return;
  const fn = console?.[method];
  if (typeof fn === 'function') {
    fn(...args);
  }
};

export const localDevLog = (...args) => runLocalConsole('log', args);
export const localDevWarn = (...args) => runLocalConsole('warn', args);
export const localDevError = (...args) => runLocalConsole('error', args);
